// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"177":"home","664":"kelas","799":"nilai","805":"participant"}[chunkId] + "." + {"177":"211faa5b","664":"8678083a","799":"146eae73","805":"6cff0e5a"}[chunkId] + ".js";
};